import { render, staticRenderFns } from "./correspondence.vue?vue&type=template&id=be477694&scoped=true&"
import script from "./correspondence.vue?vue&type=script&lang=js&"
export * from "./correspondence.vue?vue&type=script&lang=js&"
import style0 from "./correspondence.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./correspondence.vue?vue&type=style&index=1&id=be477694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be477694",
  null
  
)

export default component.exports